import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, share } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  isCompleted = true;
  step1Form: FormGroup;
  step2Form: FormGroup;
  step3Form: FormGroup;
  age;
  //url: string = 'http://localhost:30225/digitalSchool/postulant';
  //url: string = 'https://appsi.orangemali.local:4547/digitalSchool/postulant';
  //url: string = 'https://km.orangemali.com/digitalSchool/postulant';
  // url: string = 'https://kalanso.orangemali.com/digitalSchool/postulant'; actuel
  url: string = 'https://fidelite.orangemali.com/digitalSchool/postulant';

  constructor(public formBuilder: FormBuilder, public http: HttpClient, private spinner: NgxSpinnerService, public router: Router) { }

  ngOnInit() {
    this.initForm1();
    this.initForm2();
    this.initForm3();
  }

  onStep1Next($event) {
  }
  onStep2Next($event) {
  }
  onStep3Next($event) {

  }

  getAge() {
    var ageDifMs = Date.now() - (new Date(this.step1Form.value.dateNaissance)).getTime();
    var ageDate = new Date(ageDifMs); // miliseconds from epoch
    this.age = Math.abs(ageDate.getUTCFullYear() - 1970);
  }
  async onComplete($event) {
    await this.spinner.show();
    const data = {
      email: this.step1Form.value.email,
      prenom: this.step1Form.value.prenom,
      nom: this.step1Form.value.nom,
      nationalite: this.step1Form.value.nationnalite,
      telephone: this.step1Form.value.telephone,
      dateNaissance: this.step1Form.value.dateNaissance,
      age: this.step1Form.value.age,
      profession: this.step1Form.value.profession,
      genre: this.step1Form.value.genre,

      experienceEnProgrammation: this.step2Form.value.experienceEnProgrammation,
      dernierDiplome: this.step2Form.value.dernierDiplome,
      histoireParcours: this.step2Form.value.histoireParcours,
      niveauAnglais: this.step2Form.value.niveauAnglais,
      lienSiteApprentissage: this.step2Form.value.lienSiteApprentissage,
      dateDernierCDD: this.step2Form.value.dateDernierCDD,

      superHeros: this.step3Form.value.superHeros,
      hack: this.step3Form.value.hack,
      pourquoiIntegrer: this.step3Form.value.pourquoiIntegrer,
      etreDeveloppeurSertAQuoi: this.step3Form.value.etreDeveloppeurSertAQuoi,
      souhaiteAvecNewPouvoir: this.step3Form.value.souhaiteAvecNewPouvoir,
      disponibilite: this.step3Form.value.disponibilite,
      contraintes: this.step3Form.value.contraintes,
      informationFormation: this.step3Form.value.informationFormation,
      unOrdinateur: this.step3Form.value.unOrdinateur,
      souhaitPasserFormation: this.step3Form.value.souhaitPasserFormation,
    };
    console.log('data: ', data);
    this.http.post(this.url + '/save', data)
      .pipe(share(), catchError(this.handleError)).subscribe(async (data) => {
        alert("Un message a été envoyé à l'adresse " + this.step1Form.value.email);
        await this.spinner.hide();
        window.location.reload();
        console.log("test");
        // this.router.navigate(['/']);


      },
        async (err) => {
          alert("L'adresse " + this.step1Form.value.email + " est déja utilisée" + ", Merci de renseigner une autre adresse");
          await this.spinner.hide();
          //window.location.reload();
        });
  }

  initForm1() {
    this.step1Form = this.formBuilder.group({
      email: ['', [Validators.email, Validators.required]],
      prenom: ['', [Validators.required]],
      nom: ['', [Validators.required]],
      nationalite: ['', [Validators.required]],
      telephone: ['', [Validators.required]],
      dateNaissance: ['', [Validators.required]],
      age: ['', [Validators.required]],
      profession: ['', [Validators.required]],
      genre: ['', [Validators.required]]
    });
  }
  initForm2() {
    this.step2Form = this.formBuilder.group({
      experienceEnProgrammation: ['', [Validators.required]],
      dernierDiplome: ['', [Validators.required]],
      histoireParcours: ['', [Validators.required]],
      niveauAnglais: ['', [Validators.required]],
      dateDernierCDD: [''],
    });
  }
  initForm3() {
    this.step3Form = this.formBuilder.group({
      superHeros: ['', [Validators.required]],
      hack: [''],
      pourquoiIntegrer: ['', [Validators.required]],
      etreDeveloppeurSertAQuoi: ['', [Validators.required]],
      souhaiteAvecNewPouvoir: ['', [Validators.required]],
      disponibilite: ['', [Validators.required]],
      contraintes: [''],
      informationFormation: ['', [Validators.required]],
      unOrdinateur: ['', [Validators.required]],
      souhaitPasserFormation: ['', [Validators.required]],
    });
  }
  private handleError(error: HttpErrorResponse) {
    console.log('Error',
      error);
    if (error.error
      instanceof
      ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError((error.error &&
      error.error.message) ||
      'Something bad happened; please try again later.');

  }
}
